import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  emptyResultsLabel: {
    fontSize: rem(1.125),
    letterSpacing: '0.45px',
    color: themeColor.defaultTextColor,
  },
  resultsContainer: {
    // so the badge isn't clipped by overflow
    padding: '4px 0 0 4px',
  },
}));
